import styled from '@emotion/styled/macro';
import { BaseButton, forPhoneOnly, SearchBar, Variables } from '@enter/core';
import { Icon } from '@mdi/react';

export const WrappedSearchBar = styled(SearchBar)<{ autoWidth: boolean }>`
    min-width: ${({ autoWidth }) => (autoWidth ? 'unset' : undefined)};
    max-width: 600px;
`;

export const Controls = styled.div`
    display: flex;
    align-items: baseline;
    padding: 0px 16px;
    border-bottom: 1px solid #eee;
`;

export const ModeTitle = styled.span`
    font-size: 16px;
    margin-right: 16px;

    ${forPhoneOnly(`
        display: none;
    `)}
`;

export const ModeButton = styled(BaseButton)<{ active: boolean }>`
    margin: 8px 4px 0px 4px;
    padding: 0px 6px;
    text-transform: capitalize;
    border: none;
    border-radius: 0;
    border-bottom: 2px solid ${({ active }) => (active ? Variables.Colors.b300 : 'transparent')};
    color: ${({ active }) => (active ? Variables.Colors.b300 : Variables.Colors.n50)};
    background-color: ${Variables.Colors.white};
`;

export const ClaimsRow = styled.tr`
    border-top: ${Variables.Borders.regular};
`;

export const ClaimsHeader = styled.th`
    font-weight: 500;
    font-size: 14px;
    text-transform: uppercase;
    padding: 0 0 6px 0;
    text-align: left;
    color: ${Variables.Colors.p500};
`;

export const NoResults = styled.div`
    display: flex;
    align-items: center;
    align-self: center;
    flex-grow: 1;
    padding: 20px 0;
`;
export const NoResultsIcon = styled(Icon)`
    margin: 0 12px;
    & {
        fill: ${Variables.Colors.nx24};
    }
`;
export const NoResultsText = styled.div`
    line-height: 16px;
    flex-grow: 1;
    color: ${Variables.Colors.n100};
`;

export const Spacer = styled.span`
    flex-grow: 1;
`;

export const CloseButton = styled.div`
    display: flex;
    align-items: center;
    align-self: center;
`;
export const CloseIcon = styled(Icon)`
    cursor: pointer;
    & {
        fill: ${Variables.Colors.nx48};
    }
    &:hover {
        fill: ${Variables.Colors.nx100};
    }
`;

export const Header = styled.div`
    display: flex;
    align-items: center;
    height: 32px;
    padding: 0 0px;
    border-radius: 0 0 ${Variables.Rounded.small} ${Variables.Rounded.small};
    width: 100%;
`;

export const HeaderText = styled.span`
    display: inline-flex;
    align-items: center;
    margin: 0 4px 0 0;
    color: ${Variables.Colors.n100};
`;
//color: ${Variables.Colors.nx24};
